import React from "react";
import { useFamilyData } from "../../hooks/useFamilyData";

export default function AuditLogCard({ familyId }) {
  const { auditLogs = [] } = useFamilyData(familyId, { canManage: true });

  return (
    <div className="glass parent-card">
      <div className="header-flex">
        <h2>Audit Log</h2>
      </div>
      <div className="card-body">
        {auditLogs.length === 0 ? (
          <p style={{ textAlign: "center", opacity: 0.6 }}>No recent activity.</p>
        ) : (
          auditLogs.map(log => (
            <div key={log.id} className="card">
              <strong>{log.action}</strong> {log.entity}
              <div style={{ fontSize: "0.75rem", opacity: 0.7 }}>
                {log.uid?.slice(0, 6)} • {new Date(log.createdAt || 0).toLocaleString()}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
